import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.object.define-properties.js";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.filter.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { CartAdd, cartAdd, formatMoney, getFormat, pictureGenerate, setQueryParams, t } from '@process-creative/slate-theme-tools';
import { html, TemplateResult, unsafeHTML } from './../../tools/utilities/component';
import { Product } from '../../tools/product/product';
import { variantGetUrl, variantFirstAvailable } from '../../tools/product/variant';
import { LineItemProperty } from '../../tools/cart/line-item';
import { getElem } from '../../tools/utilities/helper-functions';
var ATTR_SCROLL_BUTTON_LEFT = 'data-scroll-button-left';
var ATTR_SCROLL_BUTTON_RIGHT = 'data-scroll-button-right';
var ATTR_SCROLL_BUTTON = 'data-scroll-button';
var SEL_UPSELL_ITEMS = '[data-upsell-items]';

var fetchUpsellProducts = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, cartItems) {
    var products, response, upsellProducts, i, product, inCart, availableVariant;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetch(url).then(function (response) {
              return response.json();
            });

          case 3:
            response = _context.sent;
            products = response.products;
            _context.next = 11;
            break;

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            return _context.abrupt("return");

          case 11:
            if (!products) {
              _context.next = 15;
              break;
            }

            upsellProducts = [];

            for (i = 0; i < products.length; i++) {
              product = products[i];
              inCart = product.variants.some(function (v) {
                return cartItems.some(function (i) {
                  return i.id === v.id;
                });
              });
              availableVariant = variantFirstAvailable({
                variants: product.variants
              });
              if (!inCart && availableVariant) upsellProducts.push(product);
            }

            return _context.abrupt("return", upsellProducts);

          case 15:
            return _context.abrupt("return");

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));

  return function fetchUpsellProducts(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

export function setupScrollEvent() {
  var upsellItemsElem;
  var leftBtn = getElem("[".concat(ATTR_SCROLL_BUTTON_LEFT, "]"));
  var rightBtn = getElem("[".concat(ATTR_SCROLL_BUTTON_RIGHT, "]"));
  var intervals = [];

  if (leftBtn && rightBtn) {
    upsellItemsElem = document.querySelector(SEL_UPSELL_ITEMS);
    ['touchstart', 'mousedown'].forEach(function (e) {
      leftBtn.addEventListener(e, startScrollingLeft);
      rightBtn.addEventListener(e, startScrollingRight);
    });
    ['touchend', 'mouseup'].forEach(function (e) {
      leftBtn.addEventListener(e, function (_) {
        return intervals.forEach(clearInterval);
      });
      rightBtn.addEventListener(e, function (_) {
        return intervals.forEach(clearInterval);
      });
    });
  }

  function startScrollingRight() {
    intervals.push(setInterval(function () {
      upsellItemsElem.scrollLeft += 5;
    }, 1));
  }

  function startScrollingLeft() {
    intervals.push(setInterval(function () {
      upsellItemsElem.scrollLeft -= 5;
    }, 1));
  }
}
export var storeUpsellProducts = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(collectionHandle, productId, cartItems) {
    var fetchUrl, limit, upsellProducts;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            fetchUrl = '';
            limit = 4;

            if (!collectionHandle) {
              _context2.next = 7;
              break;
            }

            // To change the limit, go to collection.json-products.liquid and do it there
            fetchUrl = "/collections/".concat(collectionHandle, "?view=json-products");
            _context2.next = 6;
            return fetchUpsellProducts(fetchUrl, cartItems);

          case 6:
            upsellProducts = _context2.sent;

          case 7:
            if (upsellProducts) {
              _context2.next = 13;
              break;
            }

            ;
            fetchUrl = "/recommendations/products.json?product_id=".concat(productId, "&limit=").concat(limit);
            _context2.next = 12;
            return fetchUpsellProducts(fetchUrl, cartItems);

          case 12:
            upsellProducts = _context2.sent;

          case 13:
            return _context2.abrupt("return", upsellProducts);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function storeUpsellProducts(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
export var cartUpsellCreate = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(upsellProducts) {
    var upsellElemItems, _iterator, _step, _loop, _ret;

    return regeneratorRuntime.wrap(function _callee5$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            upsellElemItems = "";
            _iterator = _createForOfIteratorHelper(upsellProducts);
            _context6.prev = 2;
            _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop() {
              var upsellProduct, variant, url, price, compareAtPrice, hasDiscount, image, upsellProperties, upsellSellingPlans, upsellClick, getElemString;
              return regeneratorRuntime.wrap(function _loop$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      upsellProduct = _step.value;

                      if (upsellProduct) {
                        _context5.next = 3;
                        break;
                      }

                      return _context5.abrupt("return", {
                        v: void 0
                      });

                    case 3:
                      variant = variantFirstAvailable({
                        variants: upsellProduct.variants
                      });

                      if (variant) {
                        _context5.next = 6;
                        break;
                      }

                      return _context5.abrupt("return", {
                        v: void 0
                      });

                    case 6:
                      url = variantGetUrl({
                        variant: variant,
                        product: upsellProduct
                      }); // We convert to cents here so that we can easily use the shop-money component

                      price = variant.price;
                      compareAtPrice = variant.compare_at_price ? variant.compare_at_price : null;
                      /**
                       * The product recommendations api returs a different object then our own custom
                       * object. The two objects return different price formats. The below if statements
                       * attempt to account for those diffent formats
                       */

                      if (compareAtPrice && compareAtPrice.toString().includes('.')) {
                        compareAtPrice = compareAtPrice * 100;
                      }

                      if (price.toString().includes('.')) {
                        price = variant.price * 100;
                      }

                      hasDiscount = compareAtPrice && compareAtPrice > price; // Set image

                      image = upsellProduct.images && upsellProduct.images.length > 0 ? upsellProduct.images[0].src : '';
                      /**
                       * This is gross, I know. But it's because the recommendations api is different
                       * then our typed product definition. This is a little hack to get around this for this
                       * specific instance.
                       */

                      if (!image) image = upsellProduct.images[0]; // Shopify's native variant spec doesn't include "options". So we'll update it

                      variant.options = [variant.option1, variant.option2 ? variant.option2 : '', variant.option3 ? variant.option3 : '']; // Filter out empty options

                      variant.options = variant.options.filter(function (o) {
                        return o;
                      }); // Define selling plan details inside line item properties

                      upsellProperties = null;

                      if (upsellProduct.selling_plan_groups && upsellProduct.selling_plan_groups[0]) {
                        upsellSellingPlans = upsellProduct.selling_plan_groups[0].selling_plans;

                        if (upsellSellingPlans) {
                          upsellProperties = {
                            '_selling_plans': JSON.stringify(upsellSellingPlans),
                            '_is_subscription': 'false',
                            '_selling_plan_id': 'null'
                          };
                        }
                      }

                      upsellClick = /*#__PURE__*/function () {
                        var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
                          var el, upsellContainer, upsellVariant, cartAddItem;
                          return regeneratorRuntime.wrap(function _callee3$(_context3) {
                            while (1) {
                              switch (_context3.prev = _context3.next) {
                                case 0:
                                  el = e.target;
                                  upsellContainer = el.closest('[data-upsell-item]');
                                  upsellVariant = JSON.parse(upsellContainer === null || upsellContainer === void 0 ? void 0 : upsellContainer.getAttribute('data-variant')); // Define item to add to cart

                                  cartAddItem = {
                                    id: upsellVariant.id,
                                    quantity: 1
                                  }; // Attach upsell selling plan properties if available

                                  if (upsellProperties) cartAddItem.properties = upsellProperties;
                                  _context3.prev = 5;
                                  _context3.next = 8;
                                  return cartAdd({
                                    items: [cartAddItem]
                                  });

                                case 8:
                                  _context3.next = 14;
                                  break;

                                case 10:
                                  _context3.prev = 10;
                                  _context3.t0 = _context3["catch"](5);
                                  console.error(_context3.t0);
                                  return _context3.abrupt("return");

                                case 14:
                                case "end":
                                  return _context3.stop();
                              }
                            }
                          }, _callee3, null, [[5, 10]]);
                        }));

                        return function upsellClick(_x7) {
                          return _ref4.apply(this, arguments);
                        };
                      }();

                      getElemString = /*#__PURE__*/function () {
                        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                          var _upsellProducts$;

                          var handle, metafields;
                          return regeneratorRuntime.wrap(function _callee4$(_context4) {
                            while (1) {
                              switch (_context4.prev = _context4.next) {
                                case 0:
                                  handle = upsellProducts === null || upsellProducts === void 0 ? void 0 : (_upsellProducts$ = upsellProducts[0]) === null || _upsellProducts$ === void 0 ? void 0 : _upsellProducts$.handle;
                                  _context4.next = 3;
                                  return fetch("/products/".concat(handle, "?view=metafields.json")).then(function (response) {
                                    return response.json();
                                  });

                                case 3:
                                  metafields = _context4.sent;

                                  if (variant) {
                                    _context4.next = 6;
                                    break;
                                  }

                                  return _context4.abrupt("return");

                                case 6:
                                  return _context4.abrupt("return", html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        <div\n          class=\"c-cart-upsell__item\"\n          data-upsell-item data-variant=", "\n        >\n          <div class=\"c-cart-upsell__content\">\n            <a href=\"", "\" class=\"c-cart-upsell__image-wrapper\" onclick=\"preventIfDragging(event)\">\n              <div class=\"c-cart-upsell__image-container o-responsive-image-container\">\n                ", "\n              </div>\n            </a>\n          </div>\n\n\n          <div class=\"c-cart-upsell__right\">\n\n\n            <a href=\"", "\" class=\"c-cart-upsell__details\" onclick=\"preventIfDragging(event)\">\n              <h4 class=\"c-cart-upsell__name o-tags\">\n                ", "\n              </h4>\n\n\n              ", "\n\n\n              <div class=\"c-cart-upsell__pricing o-tags\">\n                ", "\n              </div>\n\n            </a>\n\n\n            <button\n              class=\"c-cart-upsell__btn\"\n              @click=", "\n              data-upsell-add\n            >\n                <svg class=\"c-cart-upsell__btn-icon\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M3.75 12h16.5M12 3.75v16.5\" stroke=\"#22211F\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>\n\n                <span class=\"c-cart-upsell__btn-text o-tags\">\n                  ", "\n                </span>\n            </button>\n\n          </div>\n        </div>\n      "])), JSON.stringify(variant), url, unsafeHTML(pictureGenerate({
                                    class: 'c-cart-upsell__image o-responsive-image',
                                    src: image || '',
                                    srcSize: 100,
                                    sizes: [{
                                      size: 75,
                                      screen: 375
                                    }]
                                  })), url, upsellProduct.title, upsellProduct !== null && upsellProduct !== void 0 && upsellProduct.subtitle ? html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n                <p class=\"c-cart-upsell__subtitle\">\n                    ", "\n                </p>\n              "])), upsellProduct === null || upsellProduct === void 0 ? void 0 : upsellProduct.subtitle) : '', hasDiscount ? html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n                  <shop-money money=\"", "\" moneyclass=\"is-money\"\n                    compare=\"", "\" compareclass=\"is-compare\"\n                    currency=\"", "\"\n                  >\n                    ", "\n                  </shop-money>\n                "])), price, compareAtPrice, false, formatMoney(price, getFormat('', 'money_format'))) : html(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n                  <shop-money money=\"", "\" moneyclass=\"is-money\"\n                    currency=\"", "\"\n                  >\n                    ", "\n                  </shop-money>\n                "])), price, false, formatMoney(price, getFormat('', 'money_format'))), upsellClick, t('cart.upsell_add')));

                                case 7:
                                case "end":
                                  return _context4.stop();
                              }
                            }
                          }, _callee4);
                        }));

                        return function getElemString() {
                          return _ref5.apply(this, arguments);
                        };
                      }();

                      _context5.t0 = html;
                      _context5.t1 = _templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", "", ""]));
                      _context5.t2 = upsellElemItems;
                      _context5.next = 25;
                      return getElemString();

                    case 25:
                      _context5.t3 = _context5.sent;
                      upsellElemItems = (0, _context5.t0)(_context5.t1, _context5.t2, _context5.t3);

                    case 27:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _loop);
            });

            _iterator.s();

          case 5:
            if ((_step = _iterator.n()).done) {
              _context6.next = 12;
              break;
            }

            return _context6.delegateYield(_loop(), "t0", 7);

          case 7:
            _ret = _context6.t0;

            if (!(_typeof(_ret) === "object")) {
              _context6.next = 10;
              break;
            }

            return _context6.abrupt("return", _ret.v);

          case 10:
            _context6.next = 5;
            break;

          case 12:
            _context6.next = 17;
            break;

          case 14:
            _context6.prev = 14;
            _context6.t1 = _context6["catch"](2);

            _iterator.e(_context6.t1);

          case 17:
            _context6.prev = 17;

            _iterator.f();

            return _context6.finish(17);

          case 20:
            if (upsellElemItems) {
              _context6.next = 22;
              break;
            }

            return _context6.abrupt("return", html(_templateObject || (_templateObject = _taggedTemplateLiteral([""]))));

          case 22:
            return _context6.abrupt("return", html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    <div class=\"c-cart-upsell\">\n    <button class=\"c-cart-upsell__scroll-left\" title='Press to scroll left' data-scroll-button-left>\n    </button>\n    <button class=\"c-cart-upsell__scroll-right\" title='Press to scroll right' data-scroll-button-right>\n    </button>\n      <div class=\"c-cart-upsell__items\" data-upsell-items>\n        ", "\n      </div>\n    </div>\n  "])), upsellElemItems));

          case 23:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee5, null, [[2, 14, 17, 20]]);
  }));

  return function cartUpsellCreate(_x6) {
    return _ref3.apply(this, arguments);
  };
}();